import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import PdMark from './PdMark';
import { useLaunchStatus } from '../lib/launchStatus';

/**
 * Shared header for every public marketing/informational page (Landing,
 * Donate, Privacy, ForOrganisations, the guides). Same links, same order, everywhere,
 * including a link to the current page — simpler than filtering it out,
 * and harmless (AppFooter does the same). "Create account" hides during
 * coming-soon mode on every page, not just Landing.
 */
export const PublicHeader = () => {
  const navigate = useNavigate();
  const { comingSoon } = useLaunchStatus();

  return (
    <header className="px-4 sm:px-7 py-4 flex items-center justify-between gap-3">
      <Link to="/" className="flex items-center gap-3 rounded-md" aria-label="Precious Data home" data-testid="header-home-link">
        <PdMark size={28} className="text-brand" />
        <span className="font-heading text-[18px] font-bold tracking-[-0.02em] text-ink whitespace-nowrap">Precious Data</span>
      </Link>
      <nav className="flex items-center gap-4 sm:gap-6" aria-label="Main">
        <Link to="/#how-it-works" className="hidden md:inline text-[15px] text-ink-70 hover:text-ink transition-colors duration-state">
          How it works
        </Link>
        <Link to="/guides" className="hidden md:inline text-[15px] text-ink-70 hover:text-ink transition-colors duration-state" data-testid="guides-nav-btn">
          Guides
        </Link>
        <Link to="/for-organisations" className="hidden md:inline text-[15px] text-ink-70 hover:text-ink transition-colors duration-state" data-testid="for-orgs-nav-btn">
          For organisations
        </Link>
        <Link to="/donate" className="hidden sm:inline text-[15px] text-ink-70 hover:text-ink transition-colors duration-state" data-testid="donate-nav-btn">
          Donate
        </Link>
        <Button asChild variant="secondary" size="sm" data-testid="login-nav-btn">
          <Link to="/login">Sign in</Link>
        </Button>
        {!comingSoon && (
          <Button
            onClick={() => navigate('/register')}
            className="bg-ink text-white hover:bg-ink hover:opacity-90"
            data-testid="register-nav-btn"
          >
            Create account
          </Button>
        )}
      </nav>
    </header>
  );
};

export default PublicHeader;
